// Recover from stale-bundle SyntaxError: after a deploy the user's old index.html
// still references chunk filenames that no longer exist on the server. The SPA
// rewrite returns index.html (HTML) for the missing /static/js/*.chunk.js, the
// browser parses it as JS and throws "Unexpected token '<'". Force a single
// reload to pick up the fresh index.html; sessionStorage guards against loops.
//
// The browser reports that parse error as a window "error" event from the
// <script> itself, before the import() rejects, so it reaches this listener
// whether or not a React error boundary later handles the rejection.

const FLAG = "earthmap_chunk_reload_attempt";

export function installStaleChunkReload({
  target = window,
  storage = () => window.sessionStorage,
  reload = () => window.location.reload(),
} = {}) {
  const onError = (event) => {
    const filename = event.filename || (event.error && event.error.fileName);
    const message = event.message || (event.error && event.error.message) || "";
    const isChunkSyntaxError =
      typeof filename === "string" &&
      /\/static\/js\/.*\.chunk\.js/.test(filename) &&
      /Unexpected token '?<|expected expression, got '?</.test(message);
    if (!isChunkSyntaxError) return;
    const store = storage();
    const lastAttempt = Number(store.getItem(FLAG) || 0);
    if (Date.now() - lastAttempt < 60000) return;
    store.setItem(FLAG, String(Date.now()));
    reload();
  };
  target.addEventListener("error", onError);
  return () => target.removeEventListener("error", onError);
}
